import React from 'react'
import styled from 'styled-components'
import { Icon, IconSize } from '../index'

import discord from '../../assets/discord.png'
import medium from '../../assets/medium.png'
import twitter from '../../assets/twitter.png'

type SocialType = 'discord' | 'medium' | 'telegram' | 'twitter'

const ClickableIcon = styled.a`
  cursor: pointer;
`

export const SocialIcon = ({
  socialType,
  size,
}: {
  socialType: SocialType
  size?: IconSize
}) => {
  let img
  let link
  switch (socialType) {
    case 'discord':
      img = discord
      link = 'https://discord.gg/9kx6yAZh'
      break
    case 'medium':
      img = medium
      link = 'https://arcx.substack.com/'
      break
    case 'twitter':
      img = twitter
      link = 'https://twitter.com/arcxmoney'
      break
  }
  return (
    <ClickableIcon target="_blank" href={link}>
      <Icon src={img} size={size} />
    </ClickableIcon>
  )
}
